export default {
  title: {
    en: 'Tweet tweet. Our bad.',
  },
  desc: {
    en: `
      The page you are looking for does not exist.<br />
      Stay calm, take a deep breath, and smile.<br />
      Try going to scentbird.com
    `,
  },
  buttonTitle: {
    en: 'Go to scentbird.com',
  },
}
